import * as angular from "angular";
import entitySchemaValues from "../entity-schema-values/entity-schema-values";
import template from "./entity-schema-viewer.html";

export default angular
	.module("vesl.components.entity-schema-viewer", [entitySchemaValues])
	.component("entitySchemaViewer", {
		template,
		bindings: {
			actionLabel: "<",
			schema: "<",
			sectionKey: "<",
			model: "<"
		}
	})
	.name;
